import React from 'react';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';

import useFaxActions from 'components/practice/comms_center/fax/lib/useFaxActions';
import Popover from 'components/shared/Popovers/Popover/Popover';
import state from 'components/state';

import useDocActions from '../lib/useDocActions';

const FaxDocsActions = ({
  fax,
  handleConfirmationFile,
  setSelectedAppointment,
  options,
  patientId,
  practice,
  setViewDocument,
  setDownloadLoading,
  setSendFaxModal,
  isLocked,
  setShareWithPracticeModal
}) => {
  const { handleFaxDownload } = useFaxActions({ fax });

  const permissions = useRecoilValue(state.permissions);

  const hasPermissions =
    (options?.enableDocumentEdit && pm(permissions, 'patient_documents_center.update')) ||
    (fax?.patient_id === fax?.uploader_id && options.isPatient);

  const handleDownload = async () => {
    setDownloadLoading(true);
    await handleFaxDownload();
    setDownloadLoading(false);
  };

  const handleDelete = () => {
    handleConfirmationFile({
      mode: 'delete',
      id: fax?.id,
      type: 'fax',
      name: fax?.name
    });
  };

  const { appointmentLinking, sendFax, shareWithPractice, shareWithPatient } = useDocActions({
    data: fax,
    options,
    patientId,
    practice,
    setViewDocument,
    handleConfirmationFile,
    setSelectedAppointment,
    setSendFaxModal,
    setShareWithPracticeModal,
    isLocked,
    hasPermissions
  });

  const shareDocCondition =
    options?.enableDocumentSharing && fax?.uploader_id !== fax?.patient_id && fax?.patient_id;

  const popoverOptions = [
    {
      label:
        !options?.enableDocumentMarkup || isLocked || !hasPermissions ? 'View' : 'View & Markup',
      onClick: () => setViewDocument({ title: 'Fax #' + fax.id, type: 'fax', ...fax }),
      icon: 'eye-mono'
    },
    { label: 'Download', onClick: handleDownload, icon: 'file-download-mono' },

    hasPermissions &&
      !isLocked && {
        label: 'Delete',
        icon: 'trash',
        onClick: handleDelete
      },
    options?.enableAppointmentLinking && appointmentLinking,
    (options?.enableSendAsFax || options?.enableShareWithPractice || shareDocCondition) && {
      label: 'Share document',
      icon: 'share-mono',
      children: [
        options?.enableSendAsFax && sendFax,
        options?.enableShareWithPractice && shareWithPractice,
        shareDocCondition && shareWithPatient
      ].filter(Boolean)
    }
  ].filter(Boolean);

  return (
    <>
      <Popover
        className="mt-[2px] flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        isBorder={false}
        options={popoverOptions}
      />
    </>
  );
};

export default FaxDocsActions;
